/**
 * Single ApiClient instance for the whole app. Routes go through Vite's
 * dev proxy (configured in vite.config.ts) so the browser only sees the
 * same origin.
 */
import { ApiClient } from "@dfp/api-client";
import { browserTokens } from "./tokens.js";

export const api = new ApiClient({
  baseUrl: "",
  tokens: browserTokens,
  onUnauthenticated: () => {
    // Hard-redirect to /login on refresh failure. Cheap and reliable.
    if (window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
  },
});
